<div class="col text-center text-white fw-bold">Time left: <span class="count">{{ display }}</span>  </div>
